import { render, staticRenderFns } from "./WorkerNew.vue?vue&type=template&id=c525806a&"
import script from "./WorkerNew.vue?vue&type=script&lang=js&"
export * from "./WorkerNew.vue?vue&type=script&lang=js&"
import style0 from "./WorkerNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports